@if (isLoading) {
  <div class="overlay full">
    <p class="text-center">{{ appStrings.pleaseWait }}</p>
    <mat-spinner id="productsLoader"></mat-spinner>
  </div>
}

<!-- desktop template -->
<div *appIsDesktop>
  <div class="catalog-tabs" id="catalogTabs">
    @for (catalog of catalogs; track catalog) {
      <button
        class="catalog-tab"
        id="'catalogTab_' + catalog.catalogCode"
        [class.active]="catalog.catalogCode === selectedCatalogCode"
        (click)="selectCatalog(catalog.catalogCode)">
        <span class="catalog-name">{{ catalog.name }}</span>
      </button>
    }
  </div>
  @if (!isLoading && currentCategory) {
    <div class="top-div">
      <div>
        @if (currentCategory.breadcrumb.length) {
          <div class="breadcrumb">
            <a [routerLink]="['/tools/categories', selectedCatalogCode]">{{ catalogName }}</a>
            <span class="crm-industrial-font icon-right"></span>
            @for (category of currentCategory.breadcrumb; track category) {
              <div class="breadcrumb-elements">
                <a [routerLink]="['/tools/categories', selectedCatalogCode, category.id]" [innerHtml]="category.name | safe: 'html'" [attr.aria-label]="category.name"></a>
                <span class="crm-industrial-font icon-right"></span>
              </div>
            }
            <span class="current-category-breadcrumb" [innerHtml]="currentCategory.name | safe: 'html'"></span>
          </div>
        }
        @if (!currentCategory.breadcrumb.length) {
          <div>
            <a [routerLink]="['/tools/catalogs']" class="back-link">
              <span id="categories_backToDashboard" class="crm-industrial-font icon-back"></span>
              {{ appStrings.link_backToDashboard }}
            </a>
          </div>
        }
        <div class="category-name">
          <h3 id="currentCategoryName" [innerHtml]="currentCategory.name | safe: 'html'" [class.catalog-name]="currentCategory.isCatalog"></h3>
          <span class="count-tools">{{ totalRecords }}
            <span [innerHtml]="currentCategory.name | safe: 'html'" [class.catalog-name]="currentCategory.isCatalog"></span>
          </span>
        </div>
      </div>
      <app-search-product> </app-search-product>
    </div>
    @if (!currentCategory.hasProduct) {
      <div class="container">
        @if (currentCategory.id === -1) {
          <div class="categories-container">
            @for (item of currentCategory.subcategories; track item; let index = $index) {
              <div class="product-category">
                <a id="subcategory_{{index}}" [routerLink]="['/tools/categories', selectedCatalogCode, item.id]">
                  <span class="product-name" [innerHtml]="item.name | safe: 'html'"></span>
                  <img class="img" [src]="item.image || noImage" alt="{{item.name}}" appImageFallback />
                </a>
              </div>
            }
          </div>
        } @else {
          <ul class="subcategories-list">
            @for (item of currentCategory.subcategories; track item; let index = $index) {
              <li
                [class.first]="index===0 || index===1 || index===2">
                <a id="subcategory_{{index}}" [routerLink]="['/tools/categories', selectedCatalogCode, item.id]" class="category-content">
                  <img class="img" [src]="item.image || noImage" alt="{{item.name}}" appImageFallback />
                  <span class="product" [innerHtml]="item.name | safe: 'html'"></span>
                  <div class="icon-next">
                    <span class="crm-industrial-font icon-back material-icons"></span>
                  </div>
                </a>
              </li>
            }
          </ul>
        }
      </div>
    } @else {
      @if (productsList.length) {
        <div class="product-list-container">
          <div class="product-list">
            @for (product of productsPage; track product; let i = $index) {
              <div class="product-div">
                <a id="product_{{index}}" class="product-link" (click)="openProduct(product)">
                  <img class="img" [src]="product.image || noImage" alt="{{product.name}}" appImageFallback />
                  <span class="part-number">{{ appStrings.products_gridPartNo }}
                    <span class="part-no">{{ product.productNumber }}</span>
                  </span>
                  <span class="product-name" [innerHtml]="product.name | safe: 'html'"></span>
                </a>
              </div>
            }
          </div>
        </div>
      } @else {
        <span class="no-results text-center">{{ appStrings.noResults }}</span>
      }
      @if (currentCategory.hasProduct) {
        <div class="text-center">
          <mat-paginator [id]="productsListPaginator" [length]="totalRecords" [pageSize]="pageSize" [hidePageSize]="true"
            [showFirstLastButtons]="true" (page)="loadPage($event)" [pageIndex]="currentPage">
          </mat-paginator>
        </div>
      }
    }
  }

</div>

<!-- mobile template -->
<div *appIsMobile class="mobile">
  <div class="catalog-tabs" id="catalogTabs">
    @for (catalog of catalogs; track catalog) {
      <button
        class="catalog-tab"
        [class.active]="catalog.catalogCode === selectedCatalogCode"
        (click)="selectCatalog(catalog.catalogCode)"
        [id]="'catalogTab_' + catalog.catalogCode">
        <span class="catalog-name">{{ catalog.name }}</span>
      </button>
    }
  </div>
  @if (!isLoading && currentCategory) {
    <app-breadcrumbs [breadcrumb]="currentCategory.breadcrumb" [currentCategory]="currentCategory.name" [catalogCode]="selectedCatalogCode" [catalogName]="catalogName"></app-breadcrumbs>
    <app-search-product> </app-search-product>
    <div class="title">
      <span>{{ appStrings.menu_Products }}</span>
    </div>
    <div class="category-name-container">
      <span class="category-name" id="currentCategoryName" [innerHtml]="currentCategory.name | safe: 'html'" [class.catalog-name]="currentCategory.isCatalog"></span>
      <span class="count-tools">{{ " (" + totalRecords + ")" }}</span>
    </div>
    @if (!currentCategory.hasProduct) {
      <div class="subcategories-wrapper">
        @if (currentCategory.id === -1) {
          @for (category of currentCategory.subcategories; track category; let index = $index) {
            <div id="categoryContainer_{{index}}">
              <mat-card appearance="outlined">
                <mat-card-content>
                  <a class="subcategory top-level-category" id="subcategory_{{index}}" [routerLink]="['/tools/categories', selectedCatalogCode, category.id]">
                    <span class="subcategory-name" id="subcategoryName_{{index}}" [innerHtml]="category.name | safe: 'html'"></span>
                    <img id="subcategoryImage_{{index}}" [src]="category.image || noImage" alt="{{category.name}}" appImageFallback>
                  </a>
                </mat-card-content>
              </mat-card>
            </div>
          }
        } @else {
          @for (category of currentCategory.subcategories; track category; let index = $index) {
            <div id="categoryContainer_{{index}}">
              <mat-card appearance="outlined">
                <mat-card-content>
                  <a class="subcategory" id="subcategory_{{index}}" [routerLink]="['/tools/categories', selectedCatalogCode, category.id]">
                    <img id="subcategoryImage_{{index}}" [src]="category.image || noImage" alt="{{category.name}}"
                      appImageFallback>
                      <span class="subcategory-name" id="subcategoryName_{{index}}" [innerHtml]="category.name | safe: 'html'"></span>
                    </a>
                  </mat-card-content>
                </mat-card>
              </div>
            }
          }
        </div>
      }
      @if (currentCategory.hasProduct) {
        @if (productsList.length) {
          <div class="subcategories-wrapper">
            @for (product of productsPage; track product; let i = $index) {
              <div>
                <mat-card appearance="outlined">
                  <mat-card-content>
                    <a class="subcategory product-link" id="product_{{index}}" (click)="openProduct(product)">
                      <span class="part-number">{{ product.productNumber }}</span>
                      <img class="img" [src]="product.image || noImage" alt="{{product.name}}" appImageFallback />
                      <span class="subcategory-name" [innerHtml]="product.name | safe: 'html'"></span>
                    </a>
                  </mat-card-content>
                </mat-card>
              </div>
            }
            @if (currentCategory.hasProduct && pageSize < totalRecords) {
              <div class="pagination-container text-center">
                <mat-card appearance="outlined">
                  <mat-card-content>
                    <mat-paginator [id]="productsListPaginator" [length]="totalRecords" [pageSize]="pageSize" [hidePageSize]="true"
                      [showFirstLastButtons]="true" (page)="loadPage($event)" [pageIndex]="currentPage">
                    </mat-paginator>
                  </mat-card-content>
                </mat-card>
              </div>
            }
          </div>
        } @else {
          <span class="no-results text-center">{{ appStrings.noResults }}</span>
        }
      }
    }
  </div>

  <!-- common -->
